module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAARCAYAAAAougcOAAAACXBIWXMAAAsSAAALEgHS3X78AAAA+ElEQVQ4jd2UzQ3CMAxGXxF3GIENQKKiR9wR2KBswAYwAhsAG7AB5hgph7IBbFAmCIcUVJUflRY44EsUO/GLk3wOhqPxAFCgw/t2AMQazV4tatVI/LYFzrmvQ35Syf9A2p9KFEayBARYWqPrYixwzhFGMgO6FXJtrdH0AWABzAuu2BrVG2Q4GifAquKBT9ZorwR4tP+M108KDSspAc54QRdHsUbT2joJIxFgl083wBF/ZRNgAfRzUK/J75IrwBpNCv4sjx3wFQ2aQNb4B07KgbyXCRADae0vbI0e8Vf0LJ7hG++PxBhGUrXVT8siq2qfrGQL7IE7sV4AKexcKYiJvksAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/manager/mentee_list_sort_ascending.png
// module id = chaz
// module chunks = 0